import styled, { css, DefaultTheme } from 'styled-components';

export const getFontStyles = (theme: DefaultTheme) => {
  return css`
    font-size: ${theme.typography.variants.paragraph1.fontSize};
    line-height: ${theme.typography.variants.paragraph1.lineHeight};
    font-family: ${theme.typography.variants.paragraph1.fontFamily};
  `;
};

export const getColorStyles = (errorMessage: string | null, notEditable: boolean, theme: DefaultTheme) => {
  if (errorMessage) {
    return css`
      color: ${theme.colors.text.primary};
      border-color: ${theme.colors.palette.red} !important;
    `;
  }

  if (notEditable) {
    return css`
      color: ${theme.colors.text.primary};
      border-color: ${theme.colors.background.secondary.BG1} !important;
      background-color: ${theme.colors.background.secondary.BG1} !important;
      user-select: none;
    `;
  }

  return css`
    color: ${theme.colors.text.primary};
    border-color: ${theme.colors.palette.lightPurple};
  `;
};

export const ErrorMessageWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
`;

export const StyledTextareaContainer = styled.div`
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width ?? 'fit-content'};
  margin: ${(props) => props.margin ?? '0px'};
`;

export const TextareaWrapper = styled.div`
  position: relative;

  :focus,
  :hover {
    textarea {
      border-color: ${(props) => props.theme.colors.palette.purple};
    }
  }
`;

export const StyledTextarea = styled.textarea<{
  colorStyles: boolean;
  fontStyles: boolean;
  width: string;
  margin: string | number;
}>`
  background-color: rgb(250, 250, 250);
  border-width: 1px;
  border-style: solid;
  border-radius: 20px;
  outline: 0;
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  resize: vertical;
  padding: 12px;
  ${(props) => props.colorStyles};
  ${(props) => props.fontStyles};

  ::placeholder {
    color: ${(props) => props.theme.colors.text.disabled};
    font-size: ${(props) => props.theme.typography.variants.paragraph2.fontSize};
    line-height: normal;
    font-family: ${(props) => props.theme.typography.variants.paragraph2.fontFamily};
  }

  :disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.colors.text.disabled} !important;
    border-color: ${(props) => props.theme.colors.border.darker} !important;
    background-color: ${(props) => props.theme.colors.background.secondary.BG1} !important;
  }

  :disabled::placeholder {
    color: ${(props) => props.theme.colors.text.disabled};
  }
`;
